<mat-card appearance="outlined" class="vc-card mat-elevation-z5">
	<mat-card-header>
		<div class="title-container flex">
			<h2 class="basis-4/5">Dx Events Summary</h2>
			<div class="flex grow justify-end align-middle items-center">
				@if (reportingEnabled) {
					<a class="report-icon-button"
						[routerLink]="['/reporting']"
						[queryParams]="{ report: DIAGNOSIS_EVENTS_SUMMARY_NAME, year: serviceYear }"
						aria-label="Generate DX Events Summary report"
						[matTooltip]="'Generate Report'"
						[matTooltipClass]="'app-tooltip'"
						[matTooltipPosition]="'above'">
						<span class="material-symbols-outlined report-icon" aria-hidden="true">export_notes</span>
					</a>
				}

				@if (!reportingEnabled) {
					<span
						[matTooltip]="'Contact Admin for Access to Generate Report'"
						[matTooltipClass]="'app-tooltip'"
						[matTooltipPosition]="'above'">
						<button type="button" class="report-icon-button" disabled aria-label="Generate DX Events Summary report unavailable" aria-disabled="true">
							<span class="material-symbols-outlined report-icon" aria-hidden="true">export_notes</span>
						</button>
					</span>
				}
			</div>
		</div>
	</mat-card-header>

	<mat-card-content class="vc-card-summary-grid">
		<div class="summary-grid summary-grid-header header-tile">
			<div class="summary-label-header summary-toggle-header">
				<div class="toggle-container">
					<mat-slide-toggle color="accent" [(ngModel)]="summaryDxSwitch" [hideIcon]="true">
						<span>DX View</span>
					</mat-slide-toggle>
				</div>
			</div>
			<div class="summary-value-header">
				<h2>{{ summaryDxSwitch ? 'DXs' : 'HCCs' }}</h2>
			</div>
			<div class="summary-value-header">
				<h2>%</h2>
			</div>
		</div>

		@if (loading) {
			<div class="summary-empty-state">Loading summary...</div>
		}

		@if (!loading) {
			<div class="summary-body">
			@for (row of visibleRows; track row.key) {
				<div class="summary-grid" [ngClass]="{
					'header-tile': row.level === 0,
					'summary-section-divider': isOpenStateRow(row),
					'summary-row-status': row.level === 2,
					'summary-row-leaf': row.level === 3
				}">
					<div class="summary-label-cell" [style.padding-left.px]="getLabelPadding(row)">
						@if (canToggleRow(row)) {
							<button type="button" class="expand-button" (click)="toggleRow(row)" [attr.aria-label]="'Toggle ' + row.label">
								<mat-icon>{{ isExpanded(row) ? 'expand_less' : 'expand_more' }}</mat-icon>
							</button>
						}

						@if (row.level === 3) {
							<span class="expand-spacer"></span>
						}

						@if (row.level <= 2) {
							<h3>{{ row.label }}</h3>
						}

						@if (row.level > 2) {
							<p>{{ row.label }}</p>
						}
					</div>

					<div class="summary-value-cell">
						@if (row.level <= 2) {
							<h3>{{ getSelectedCount(row) | number }}</h3>
						}

						@if (row.level > 2) {
							<p>{{ getSelectedCount(row) | number }}</p>
						}
					</div>
					<div class="summary-value-cell">
						@if (getSelectedPercent(row) !== null) {
							@if (row.level <= 2) {
								<h3>{{ getSelectedPercent(row) | percent }}</h3>
							}

							@if (row.level > 2) {
								<p>{{ getSelectedPercent(row) | percent }}</p>
							}
						}
					</div>
				</div>
			}
			</div>
		}

		@if (refreshDate) {
			<label class="data-refresh-label">Data Refreshed {{ refreshDate | date: 'MM/dd/yyyy' }}</label>
		}
	</mat-card-content>
</mat-card>
